;(function () {

"use strict";

var _ = require('underscore');

var CheckboxListView = Backbone.View.extend({
  initialize: function () {
    console.log('init checkbox list view');
    this.vals = {};

    var self = this;
    this.$el.find('input[type="checkbox"]').each(function () {
      self.vals[$(this).attr('name')] = $(this).prop('checked');
    });

    this.$input = this.$el.find('input[type="text"]');
  },
  events: {
    'change input[type="checkbox"]': function (e) {
      var $this = $(e.currentTarget);
      var val = $this.prop('checked');
      this.vals[$this.attr('name')] = val;

      var str = '';
      // _.each(this.vals, function (val, key) {
      // });

      var self = this;
      this.$el.find('input[type="checkbox"]').each(function () {
        var name = $(this).attr('name');
        str += name + ':' + self.vals[name] + ',';
      });

      str = str.slice(0, -1)
      this.$input.val(str);
    }
  }
});

module.exports = CheckboxListView;

}());